angular.module("app").controller("HiddenGamesListPageController", [
    '$scope',
    '$uibModal',
    'preloadedProviders',
    'preloadedCategories',
    'hiddenGamesService',
    'errorHandler',
    'logger',
    'pagination',
    'userStorage',
    function ($scope, $modal, preloadedProviders, preloadedCategories, hiddenGamesService, errorHandler, logger, pagination, userStorage) {
        $scope.tabOptions = {};
        $scope.labelColumnContainer = {
            column: "providerTitle",
            field: "badge"
        };
        $scope.categoryLabelColumnContainer = {
            column: "categoryTitle",
            field: "badge"
        };

        var hasPermission = userStorage.getUserData().permissions.indexOf('manageSkinCategoriesProviders') !== -1;
        $scope.selectProviders = function (request) {
            if ($scope.filterOptions.providersSearch !== null) {
                $scope.providers = $scope.allProviders.filter(function (item) {
                    return item.providerTitle.toLowerCase().indexOf($scope.filterOptions.providersSearch.toLowerCase()) !== -1;
                });
            } else {
                $scope.providers = $scope.allProviders;
            }
            $scope.providersPagination.totalItems = $scope.providers.length;

            $scope.providers = $scope.providers.slice((request.current_page - 1) * request.limit, (request.current_page - 1) * request.limit + request.limit);

        };

        $scope.selectCategories = function (request) {
            if ($scope.filterOptions.categoriesSearch !== null) {
                $scope.categories = $scope.allCategories.filter(function (item) {
                    return (
                        item.categoryTitle.toLowerCase().indexOf($scope.filterOptions.categoriesSearch.toLowerCase()) !== -1 ||
                        item.categoryName.toLowerCase().indexOf($scope.filterOptions.categoriesSearch.toLowerCase()) !== -1 ||
                        item.id.indexOf($scope.filterOptions.categoriesSearch) !== -1
                    );
                });
            } else {
                $scope.categories = $scope.allCategories;
            }
            $scope.categoriesPagination.totalItems = $scope.categories.length;
            $scope.categories = $scope.categories.slice((request.current_page - 1) * request.limit, (request.current_page - 1) * request.limit + request.limit);

        };

        function changeLabel(item, type) {
            $modal.open({
                templateUrl: "views/pageBuilders/skillGames/gameLabel.html",
                controller: "GamesLabelPopupController",
                resolve: {
                    initialLabel: function () {
                        return item.badge;
                    }
                }
            }).result.then(function (res) {
                if (type === 'provider') {
                    service = hiddenGamesService.changeLabel({
                        id: item.id,
                        badge: res
                    })
                } else {
                    service = hiddenGamesService.changeCategoryLabel({
                        id: item.skin_category_id,
                        badge: res
                    })
                }
                service.then(function (response) {

                        if (response.status === "ok") {
                            logger.logSuccess('global.successfullyUpdated');
                            item.badge = res;
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    });
            });
        }

        function extractCategory(category) {
            return {
                id: category.category_id,
                skin_category_id: category.id,
                categoryName: category.categoryName,
                categoryTitle: category.categoryTitle,
                hidden: !category.hidden,
                badge: category.badge,
            }
        }

        preloadedProviders.items.forEach(function (value) {
            value.hidden = !value.hidden;
        });
        $scope.filterOptions = {
            categoriesSearch: null,
            providersSearch: null
        };

        $scope.allCategories = angular.copy(preloadedCategories.items).map(extractCategory);
        $scope.allProviders = angular.copy(preloadedProviders.items);
        var limits = [{value: 5}, {value: 10}, {value: 25}, {value: 50}, {value: 100}];
        $scope.providersPagination = pagination.init(function () {
            $scope.selectProviders({
                current_page: $scope.providersPagination.page,
                limit: $scope.providersPagination.limit
            });
        }, parseInt($scope.allProviders.length), 25, undefined, undefined, limits);
        $scope.categoriesPagination = pagination.init(function () {
            $scope.selectCategories({
                current_page: $scope.categoriesPagination.page,
                limit: $scope.categoriesPagination.limit
            });
        }, parseInt($scope.allCategories.length), 25, undefined, undefined, limits);

        $scope.selectCategories({
            current_page: $scope.categoriesPagination.page,
            limit: $scope.categoriesPagination.limit
        });
        $scope.selectProviders({
            current_page: $scope.providersPagination.page,
            limit: $scope.providersPagination.limit
        });

        $scope.changeTheValue = function (item, isProvider) {
            var fn = hiddenGamesService["update" + (isProvider ? 'Provider' : 'Category')],
                requestData = {
                    visibility: {
                        id: isProvider ? item.id : item.skin_category_id,
                        hidden: !item.hidden
                    }
                };
            fn(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess('global.successfullyUpdated')
                    } else {
                        item.hidden = !item.hidden;
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    item.hidden = !item.hidden;
                    errorHandler(response.message)
                }
            );
        };

        function reorder(listOfValues, serviceFunction, field = 'id') {
            if (typeof listOfValues === "object" && listOfValues.length) {
                var list = [];
                listOfValues.forEach(function (item) {
                    list.push(item[field])
                });
                serviceFunction({order: list}).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("global.updated")
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            }
        }

        $scope.ignoreColumns = {
            'category_id': true,
            'skin_category_id': true,
            'order': true,
            'skin_id': true,
            'hidden': true,
            'badge': true,
            'hasJustice': true,
            'justice': true,
        };

        $scope.categoryTools = {
            "switch": {
                name: function (item) {
                    return 'hiddenGames' + item.categoryName;
                },
                model: function () {
                    return "hidden";
                },
                change: function (item) {
                    $scope.changeTheValue(item, false);
                },
                disabled: !hasPermission
            },
            "changeLabel": {
                title: function () {
                    return "Change Badge"
                },
                class: function () {
                    return "category-label animated bounceIn";
                },
                action: function (item) {
                    changeLabel(item, 'category');
                }
            }

        };

        $scope.providersTools = {
            "changeLabel": {
                title: function () {
                    return "Change Badge"
                },
                class: function () {
                    return "category-label animated bounceIn";
                },
                action: function (item) {
                    changeLabel(item, 'provider');
                }
            }
        };

        $scope.categoriesListFilterObject = {
            action: function () {
                $scope.selectCategories({
                    current_page: $scope.categoriesPagination.page,
                    limit: $scope.categoriesPagination.limit
                });
            }
        };
        $scope.providersListFilterObject = {
            action: function () {
                $scope.selectProviders({
                    current_page: $scope.providersPagination.page,
                    limit: $scope.providersPagination.limit
                });
            }
        };

        if (hasPermission) {
            $scope.allowUpdateProvidersContainer = {};
            $scope.allowUpdateProvidersContainer.allowUpdate = function (options) {
                if (options && options.autoUpdate) {
                    var endIndex = ($scope.providersPagination.page - 1) * $scope.providersPagination.limit + $scope.providersPagination.limit;
                    var j = 0;
                    for (var i = ($scope.providersPagination.page - 1) * $scope.providersPagination.limit; i < endIndex; ++i) {
                        if ($scope.allProviders[i]) {
                            $scope.allProviders[i] = $scope.providers[j++];
                        } else {
                            break;
                        }
                    }
                    reorder($scope.allProviders, hiddenGamesService.changeProviderOrder);
                } else if (!!options) {
                    $scope.tabOptions.reorderedProviders = true
                }
            };

            $scope.allowUpdateCategoriesContainer = {};
            $scope.allowUpdateCategoriesContainer.allowUpdate = function (options) {
                if (options && options.autoUpdate) {
                    var endIndex = ($scope.categoriesPagination.page - 1) * $scope.categoriesPagination.limit + $scope.categoriesPagination.limit;
                    var j = 0;
                    for (var i = ($scope.categoriesPagination.page - 1) * $scope.categoriesPagination.limit; i < endIndex; ++i) {
                        if ($scope.allCategories[i]) {
                            $scope.allCategories[i] = $scope.categories[j++];
                        } else {
                            break;
                        }

                    }
                    reorder($scope.allCategories, hiddenGamesService.changeCategoryOrder, 'skin_category_id');
                } else if (!!options) {
                    $scope.tabOptions.reorderedCategories = true
                }
            };
        }
    }
]);
